module.exports = __webpack_public_path__ + "img/icon_macro_active.baa0e88d.svg";